import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/Banner.css';

function Banner({ title, subtitle, className, accent, secondaryTitle }) {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const isDutch = i18n.resolvedLanguage?.startsWith('nl');
  const pageLabels = {
    '/services': isDutch ? 'Diensten & tarieven' : 'Services & tarifs',
    '/about': isDutch ? 'Over ons' : 'À propos',
    '/reservation': isDutch ? 'Reserveren' : 'Réservation',
    '/faq': 'FAQ',
    '/contact': 'Contact',
    '/policy': isDutch ? 'Privacybeleid' : 'Confidentialité',
    '/transport-medico-sanitaire-bruxelles': isDutch ? 'Medisch vervoer' : 'Transport médico-sanitaire',
    '/transport-pmr-bruxelles': isDutch ? 'Aangepast vervoer' : 'Transport PMR et TPMR',
    '/transport-dialyse-bruxelles': isDutch ? 'Dialysevervoer' : 'Transport dialyse',
    '/transport-hopital-bruxelles': isDutch ? 'Ziekenhuisvervoer' : 'Transport hôpital',
    '/transport-seniors-bruxelles': isDutch ? 'Seniorenvervoer' : 'Transport seniors',
    '/remboursement-transport-medical': isDutch ? 'Terugbetaling' : 'Remboursement',
    '/transport-medical-anderlecht': isDutch ? 'Vervoer in Anderlecht' : 'Transport à Anderlecht'
  };

  const renderTitle = () => {
    if (!accent) return title;

    const titleText = String(title);
    const accentIndex = titleText.toLocaleLowerCase().lastIndexOf(String(accent).toLocaleLowerCase());
    if (accentIndex < 0) return title;

    return (
      <>
        {titleText.slice(0, accentIndex)}
        <span className="banner-title-accent">{titleText.slice(accentIndex, accentIndex + accent.length)}</span>
        {titleText.slice(accentIndex + accent.length)}
      </>
    );
  };

  return (
    <header className={`banner page-intro ${className || ''}`}>
      <div className="banner-content">
        <nav className="page-breadcrumb" aria-label={isDutch ? 'Kruimelpad' : 'Fil d’Ariane'}>
          <Link to="/">{isDutch ? 'Home' : 'Accueil'}</Link><span>/</span><strong>{pageLabels[pathname] || title}</strong>
        </nav>
        <span className="banner-kicker"><i></i>{pageLabels[pathname] || 'Main Tendue'}</span>
        <h1>{renderTitle()}{secondaryTitle && <span className="banner-secondary-title">{secondaryTitle}</span>}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </header>
  );
}

export default Banner;
